import './src/shared/init'


import Glide from '@glidejs/glide'
import './controllers'

import 'mousetrap'



var doc = document.documentElement;
doc.setAttribute('data-useragent', navigator.userAgent);


const log2 = (val) => {
    return Math.log(val) / Math.LN2;
}

document.addEventListener('turbo:load', () => {

    console.log('application')

    if (document.querySelector('.glide')) {
        new Glide('.glide', {
            type: 'carousel',
            perView: 4,
            focusAt: 'center',
            autoplay: 4000,
            hoverpause: true,
            width: 'auto',
            breakpoints: {
                800: {
                    perView: 2
                },
                480: {
                    perView: 1
                }
            }
        }).mount()
    }

    $('ul.select-dropdown.select-icon').each(function () {
        $(this).find('li').each(function () {
            $(this).find('span').html('<i class="fal ' + $(this).find('span').html() + '"></i>' + $(this).find('span').html());
        });
    });

    $('.go-to-upload-step-2').on('click', function (e) {
        e.preventDefault()
        $('.upload-step-1').fadeOut()
    });

    $('body').find('form').on('submit', function () {
        $(this).find('input[type="submit"]').prop('disabled', true);
        $(this).find('input[type="submit"]').val($('body').data('sending'));
    })

    const updatePrice = () => {
        const priceElement = $('[name="ticket_order[ticket_type_payment_method_id]"]:checked').closest('.form-check').find('.price').html()

        const price = (priceElement) ? parseFloat(priceElement) : 0

        $('.money-count').html(($('#ticket_order_ticket_count').val() * price) + "€");
    }

    const inputChange = () => {
        $('.ticket-choice[data-type-id=""]')
        $('#ticket-selector .tickets').attr('data-selected', $('#ticket_order_ticket_count').val());

        updatePrice()
    }

    const ticketTypeChange = (e) => {
        $(`#ticket-selector .ticket-choice.active`).removeClass('active')
        $(`#ticket-selector .ticket-choice[data-type-id="${e.target.value}"]`).addClass('active')

        $('.ticket-prices').removeClass('active')
        $(`.ticket-prices input`).attr('disabled', true)
        $(`.ticket-prices[data-type-id="${e.target.value}"]`).addClass('active')
        $(`.ticket-prices[data-type-id="${e.target.value}"] input`).attr('disabled', false)

        updatePrice()
    }

    $('[name="ticket_order[ticket_type_id]"]').on('change', ticketTypeChange);
    $('#ticket_order_ticket_count, [name="ticket_order[ticket_type_id]"], [name="ticket_order[ticket_type_payment_method_id]"]').on('change', inputChange);

    inputChange()

});